export default __webpack_public_path__ + "static/media/20.cf3d8459.jpg";